/**
 *  @class Cache class for managing the scan elements that manages localy stored data.
 */

import * as THREE from 'three';
import { Object3D } from 'three';

import { MemoryManager } from '../memory-manager';
import { CacheElement } from './cache-element';

export default class ScanChunkCache extends CacheElement {
  constructor(key: string, data: any, clearTimeout: number, clearCallback: any, size = 0) {
    super(key, data, clearTimeout, clearCallback, size, 'scan');
  }

  dispose() {
    this.data.parent?.remove(this.data);

    function clearNode(node: THREE.Object3D) {
      if (node instanceof THREE.Mesh) {
        node.geometry.dispose();

        if (node.material) {
          if (Array.isArray(node.material)) {
            node.material.map((material) => {
              material.dispose();
              material?.map?.dispose();
            });
          } else {
            node.material.dispose();
            node.material?.map?.dispose();
          }
        }
      }

      node.children?.map((child) => {
        clearNode(child);
      });
    }
    clearNode(this.data as Object3D);

    MemoryManager.getInstance().release(this.getSize(), this.type);
  }
}
